module.exports = "#logoutContainer{ \n        background-color: #f2f2f2; \n        padding:20px; \n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout/logout.component.css
// module id = ./src/app/logout/logout.component.css
// module chunks = main